import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AviaService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'avia';

  getICAO(filter): Observable<any> {
    const station = filter.station ? 'station=' + (filter.station) : '';
    const params = `?${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/icao' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getWeek2(filter): Observable<any[]> {
    // console.log('filter',filter)
    const station = filter.station ? 'station=' + (filter.station) : '';
    const timezone = Number(filter.timezone) ? 't=' + Number(filter.timezone) : '';
    const params = `?${station}&${timezone}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/week2' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any[]>(uri, {headers: headers});
  }
  getLast(): Observable<any[]> {
    // const station = filter.station ? 'station=' + (filter.station) : '';
    // const params = `?${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/last';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any[]>(uri, {headers: headers});
  }
  getMap(): Observable<any[]> {
    // const station = filter.station ? 'station=' + (filter.station) : '';
    // const params = `?${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/map';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any[]>(uri, {headers: headers});
  }
  getGraph(filter): Observable<any[]> {
    const station = filter.station ? 'station=' + (filter.station) : '';
    const params = `?${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/graph' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any[]>(uri, {headers: headers});
  }

  getList(): Observable<GeoAirport[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/list';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<GeoAirport[]>(uri, {headers: headers});
  }

}

interface GeoAirport {
  CALL_SIGN: string,
  ID_COUNTRY: string,
  NAME_ST: string,
  LATITUDE: number,
  LONGITUDE: number,
  ELEVATION: number
}